import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TestimonialsTop } from './components/TestimonialsTop';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { EbookDetails } from './components/EbookDetails';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { KitProDetails } from './components/KitProDetails';
import { TestimonialsBottom } from './components/TestimonialsBottom';
import { FaqSection } from './components/FaqSection';
import { CostComparison } from './components/CostComparison';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  return <div className="min-h-screen bg-background text-white font-body selection:bg-brand selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StatsBar data-id="element-2" />
      <TestimonialsTop data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <EbookDetails data-id="element-6" />
      <BonusSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <KitProDetails data-id="element-9" />
      <TestimonialsBottom data-id="element-10" />
      <FaqSection data-id="element-11" />
      <CostComparison data-id="element-12" />
      <FinalCta data-id="element-13" />
      <Footer data-id="element-14" />
      <SocialProofToast data-id="element-15" />
    </div>;
}